<template>
	<tr>
		<td data-th="Singer">
			<div class="row">
				<div class="col-sm-2 d-none d-sm-block">
					<img :src="require(`@/assets/images/${singer.thumbnail_url}.png`)" alt="..." class="img-fluid"/>
				</div>
				<div class="col-sm-10">
					<h4 class="nomargin">{{ singer.title }}</h4>
					<p>{{ singer.description }}</p>
				</div>
			</div>
		</td>
		<td data-th="Price">{{ singer.accountId }}</td>
		<td data-th="Balance">{{ tokens[0].balance }}</td>
		<td data-th="Hbar" class="text-center">{{ tokens[0].hbarBalance }}</td>
		<td data-th="Hbar" class="text-center">{{ singer.wallet }}</td>
	</tr>
</template>

<script>
	import { mapActions } from 'vuex';
	import { accountGetInfo } from "@/service/accountInfo";
	import { EventBus } from "@/eventBus";

	export default {
		data() {
			return {
				tokens: {}
			}
		},
		props: ['singer'],
		computed: {
			subtotal() {
				return this.singer.quantity * this.singer.price;
			},
		},
		methods: {
			...mapActions(['updateCart', 'removeItemInCart']),
			updateQuantity(event) {
				let vm = this;
				this.updateCart({
					item: vm.singer,
					quantity: parseInt(event.target.value),
					isAdd: false
				});
			},
			async getTokens() {
				const resultTokens = [];
				const tokenRelationships = await accountGetInfo(this.singer.accountId);
				for (const key in tokenRelationships) {
					const tokenRelationship = tokenRelationships[key];
					resultTokens.push(tokenRelationship);
				}
				this.tokens = resultTokens;
			},
		},
		created() {
			this.getTokens();
			EventBus.$on('updateToken', (isUpdate) => {
				if(isUpdate) {
					this.getTokens();
				}
			})
		}
	}
</script>
